/**
 * Theme Injector - Dynamically updates inline styles when theme changes
 * This ensures components with hardcoded inline styles also get themed
 */

export const injectThemeToInlineStyles = () => {
    const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-color').trim();
    const primaryTextColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-text-color').trim();
    const primaryHover = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-hover').trim();

    if (!primaryColor) return;

    // Common blue hex colors to replace
    const blueColors = [
        '#1890ff',
        '#0080ff',
        '#1967D2',
        '#4285F4',
        'rgb(24, 144, 255)',
        'rgb(0, 128, 255)',
        'rgb(25, 103, 210)',
        'rgb(66, 133, 244)'
    ];

    // Find all elements with inline styles
    const allElements = document.querySelectorAll('*[style]');

    allElements.forEach(element => {
        const style = element.getAttribute('style');
        if (!style) return;

        let updated = false;
        let newStyle = style;

        // Check if any blue color is used
        blueColors.forEach(blueColor => {
            if (style.includes(blueColor)) {
                // Replace background colors
                if (style.includes(`background-color: ${blueColor}`) ||
                    style.includes(`backgroundColor: ${blueColor}`)) {
                    newStyle = newStyle.replace(
                        new RegExp(`background-color:\\s*${blueColor.replace(/[()]/g, '\\$&')}`, 'gi'),
                        `background-color: ${primaryColor}`
                    );
                    newStyle = newStyle.replace(
                        new RegExp(`backgroundColor:\\s*${blueColor.replace(/[()]/g, '\\$&')}`, 'gi'),
                        `backgroundColor: ${primaryColor}`
                    );
                    updated = true;
                }

                // Replace border colors
                if (style.includes(`border-color: ${blueColor}`) ||
                    style.includes(`borderColor: ${blueColor}`)) {
                    newStyle = newStyle.replace(
                        new RegExp(`border-color:\\s*${blueColor.replace(/[()]/g, '\\$&')}`, 'gi'),
                        `border-color: ${primaryColor}`
                    );
                    newStyle = newStyle.replace(
                        new RegExp(`borderColor:\\s*${blueColor.replace(/[()]/g, '\\$&')}`, 'gi'),
                        `borderColor: ${primaryColor}`
                    );
                    updated = true;
                }

                // Replace text colors
                if (style.includes(`color: ${blueColor}`)) {
                    newStyle = newStyle.replace(
                        new RegExp(`color:\\s*${blueColor.replace(/[()]/g, '\\$&')}`, 'gi'),
                        `color: ${primaryColor}`
                    );
                    updated = true;
                }
            }
        });

        if (updated) {
            element.setAttribute('style', newStyle);
        }
    });

    console.log('✅ Theme injector: Updated inline styles');
};

// Listen for theme changes
if (typeof window !== 'undefined') {
    window.addEventListener('themeChanged', () => {
        setTimeout(() => {
            injectThemeToInlineStyles();
        }, 100);
    });

    // Run on initial load
    setTimeout(() => {
        injectThemeToInlineStyles();
    }, 500);
}

export default injectThemeToInlineStyles;
